/**
 * @description: 广场路由文件
 * @author: lx
 * @Compile：2022-05-31 10：00
 * @update: lx(2022-05-31 10：00)
 */
export default [
  {
    path: "/circleCheck",
    component: () => import("../../pages/lookfor/square/circleCheck/circleCheck.vue"),
    name: "circleCheck",
    title: "圈子审核管理",
    meta: {
      title: "圈子审核管理"
    }
  },
  {
    path: "/circle",
    component: () => import("../../pages/lookfor/square/circle/circle.vue"),
    name: "circle",
    title: "圈子管理",
    meta: {
      title: "圈子管理"
    }
  },
  {
    path: "/circleCate",
    component: () => import("../../pages/lookfor/square/circle/circleCate.vue"),
    name: "circle",
    title: "圈子分类管理",
    meta: {
      title: "圈子分类管理"
    }
  },
  {
    path: "/circleDetail",
    component: () => import("../../pages/lookfor/square/circle/circleDetail.vue"),
    name: "circleDetail",
    title: "圈子详情",
    meta: {
      title: "圈子详情"
    }
  },
  {
    path: "/lookforBanner",
    component: () => import("../../pages/lookfor/square/banner.vue"),
    name: "lookforBanner",
    title: "banner管理",
    meta: {
      title: "banner管理"
    }
  },
  {
    path: "/topic",
    component: () => import("../../pages/lookfor/square/topic/topic.vue"),
    name: "topic",
    title: "话题管理",
    meta: {
      title: "话题管理"
    }
  },
  {
    path: "/status",
    component: () => import("../../pages/lookfor/square/status/status.vue"),
    name: "status",
    title: "帖子管理",
    meta: {
      title: "帖子管理"
    }
  },
  {
    path: "/surveyFeedback",
    component: () => import("../../pages/lookfor/square/surveyFeedback/surveyFeedback.vue"),
    name: "surveyFeedback",
    title: "反馈管理",
    meta: {
      title: "反馈管理"
    }
  },
  {
    path: "/statusEvaluation",
    component: () => import("../../pages/lookfor/square/evaluation/evaluation.vue"),
    name: "statusEvaluation",
    title: "帖子评论管理",
    meta: {
      title: "帖子评论管理"
    }
  },
]
